import fetchLogger from "./fetchLogger";

/** GET /api/v1/issues/:id */
export default async function getIssue(id) {
  const result = { return: 0, msg: "Failed fetching issue", data: null };

  const res = await fetchLogger({
    method: "GET",
    url: `/api/v1/issues/${id}`,
  });

  if (res.ok) {
    result.return = 1;
    result.msg = "Successful";
    result.data = res.data?.data || null;
  } else {
    const message = res.data?.message;
    result.msg = Array.isArray(message) ? message.join(", ") : message || result.msg;
    result.error = res.data?.error;
    result.status = res.status;
  }

  return result;
}
